<template>
<div>
	<v-card flat max-width="950px" class="mx-auto transparent pb-12">
        <HeadRoot 
            title="Career Map"
            :length="0"
            btn_txt=""
            btn_to="" />

        <v-row class="mt-12">
            <v-col cols="12" sm="6">
                <div class="d-flex" :class="($vuetify.breakpoint.xsOnly) ? 'justify-center' : 'justify-end'">
                    <v-card flat width="300px" hover color="#6577BD" @click="$router.push('/map-of-careers/jobs-and-occupations')">
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/careers/news/jobs-salaries.png')" width="40"></v-img>
                            </div>
                            <div class="title font-weight-bold white--text py-6">
                                JOBS & SALARIES
                            </div>
                        </div>
                    </v-card>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <div class="d-flex" :class="($vuetify.breakpoint.xsOnly) ? 'justify-center' : 'justify-start'">
                    <v-card flat width="300px" hover color="#45B2DE" @click="$router.push('/map-of-careers/best-jobs')">
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/careers/news/top-jobs.png')" width="40"></v-img>
                            </div>
                            <div class="title font-weight-bold white--text py-6">
                                TOP JOBS
                            </div>
                        </div>
                    </v-card>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <div class="d-flex" :class="($vuetify.breakpoint.xsOnly) ? 'justify-center' : 'justify-end'">
                    <v-card flat width="300px" hover color="#FA5F70" @click="$router.push('/map-of-careers/best-universities')">
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/careers/news/top-universities.png')" width="40"></v-img>
                            </div>
                            <div class="title font-weight-bold white--text py-6">
                                TOP UNIVERSITIES
                            </div>
                        </div>
                    </v-card>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <div class="d-flex" :class="($vuetify.breakpoint.xsOnly) ? 'justify-center' : 'justify-start'">
                    <!-- <v-card @click="$router.push('map-of-careers/jobs-by-category')" hover style="border-radius:20px" max-width="330">
                        <v-img :src="require('@/assets/careers/jobs-category.jpg')"></v-img>
                    </v-card> -->

                    <v-card flat width="300px" hover color="#65D8AD" @click="$router.push('/map-of-careers/jobs-by-category')">
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/careers/news/jobs-by.png')" width="40"></v-img>
                            </div>
                            <div class="title font-weight-bold white--text py-6">
                                JOBS BY CATEGORY
                            </div>
                        </div>
                    </v-card>
                </div>
            </v-col>
        </v-row>
	</v-card>

    <!-- BEST 100 JOBS -->
    <!-- <v-card outlined max-width="950px" class="mx-auto pa-6" v-if="user.email=='banazak@gmail.com'">
        <div class="mb-6">BEST JOB</div>
        <v-text-field v-model="job.name" label="name" outlined dense></v-text-field>
        <v-textarea v-model="job.description" label="Description" outlined dense></v-textarea>
        <v-text-field v-model="job.wage" label="Wage" outlined dense></v-text-field>
        <v-text-field v-model="job.upwardMobility" label="upwardMobility" outlined dense></v-text-field>
        <v-text-field v-model="job.stressLevel" label="stressLevel" outlined dense></v-text-field>
        <v-text-field v-model="job.flexibility" label="flexibility" outlined dense></v-text-field>
        <v-text-field v-model="job.recommendedMajors" label="recommendedMajors" outlined dense></v-text-field>
        <v-text-field v-model="job.day" label="day" outlined dense></v-text-field>
        <v-btn block depressed class="accent" @click="addJob">ADD</v-btn>
    </v-card> -->

    <!-- BEST 100 universities -->
    <!-- <v-card outlined max-width="950px" class="mx-auto pa-6" v-if="user.email=='banazak@gmail.com'">
        <div class="mb-6">BEST UNIVERSITY</div>
        <v-text-field v-model="univ.position" label="position" outlined dense></v-text-field>
        <v-text-field v-model="univ.name" label="name" outlined dense></v-text-field>
        <v-text-field v-model="univ.location" label="location" outlined dense></v-text-field>
        <v-textarea v-model="univ.overview" label="overview" outlined dense></v-textarea>
        <v-text-field v-model="univ.pmc" label="pmc" outlined dense></v-text-field>
        <v-text-field v-model="univ.cost" label="cost" outlined dense></v-text-field>
        <v-text-field v-model="univ.howTo" label="howTo" outlined dense></v-text-field>
        <v-text-field v-model="univ.values" label="values" outlined dense></v-text-field>
        
        <v-btn block depressed class="accent" @click="addUniv">ADD</v-btn>
    </v-card> -->

    <!-- TOP 3 Univ -->
    <!-- <v-card outlined max-width="950px" class="mx-auto pa-6" v-if="user.email=='banazak@gmail.com'">
        <div class="mb-6">BEST JOB</div>
        <v-text-field v-model="top.name" label="name" outlined dense></v-text-field>
        <v-text-field v-model="top.top3Univ" label="top3Univ" outlined dense></v-text-field>
        <v-btn block depressed class="accent" @click="setTop3">SET</v-btn>
    </v-card> -->
</div>
</template>

<script>
import Careers from '@/firebase/careers'

export default {
    data: () => ({
        job: {
            name: '',
            description: '',
            wage: '',
            upwardMobility: '',
            stressLevel: '',
            flexibility: '',
            recommendedMajors: '',
            day: ''
        },
        univ: {
            position: '',
            name: '',
            location: '',
            overview: '',
            pmc: '',
            cost: '',
            howTo: '',
            values: ''
        },
        top: {
            name: '',
            top3Univ: ''
        }
    }),
    methods: {
        // addJob() {
        //     this.job.wage = parseInt(this.job.wage);

        //     if (this.validateIsEmpty(this.job.day)) {
        //         delete this.job.day;
        //     }

        //     this.job.description = '<p>' + this.job.description.replace('\n', '</p><p>') + '</p>';

        //     Careers.addBestJob(this.job)
        //             .then(response => {
        //                 if (response === true) {
        //                     this.job = {
        //                         name: '',
        //                         description: '',
        //                         wage: '',
        //                         upwardMobility: '',
        //                         stressLevel: '',
        //                         flexibility: '',
        //                         recommendedMajors: '',
        //                         day: ''
        //                     }
        //                     this.$store.dispatch('setSnack', {kind:'success', text:'Todo bien.'});
        //                 }
        //             });
        // },
        // addUniv() {
        //     this.univ.position = parseInt(this.univ.position);

        //     this.univ.overview = '<p>' + this.univ.overview.replace('\n', '</p><p>') + '</p>';
        //     this.univ.values = '<p>' + this.univ.values.replace('\n', '</p><p>') + '</p>';

        //     Careers.addBestUniversity(this.univ)
        //             .then(response => {
        //                 if (response === true) {
        //                     this.univ = {
        //                         position: '',
        //                         name: '',
        //                         location: '',
        //                         overview: '',
        //                         pmc: '',
        //                         cost: '',
        //                         howTo: '',
        //                         values: ''
        //                     }
        //                     this.$store.dispatch('setSnack', {kind:'success', text:'Todo bien.'});
        //                 }
        //             });
        // },
        // setTop3() {
        //     Careers.setTop3Univ(this.top.name, this.top.top3Univ)
        //             .then( response => {
        //                 if (response === true) {
        //                     this.top = {
        //                         name: '',
        //                         top3Univ: ''
        //                     }
        //                     this.$store.dispatch('setSnack', {kind:'success', text:'Todo bien.'});
        //                 }
        //             });
        // }
    }

}
</script>




